var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDasshboardMaintenanceInUnit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 35,
    viewBox: "0 0 37.668 46.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_8425",
    x: 0,
    y: 0,
    width: 37.668,
    height: 46.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12382",
    "data-name": "Group 12382",
    transform: "translate(5.234 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.23, -6)",
    filter: "url(#Path_8425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8425-2",
    "data-name": "Path 8425",
    d: "M-1277.545,815.073h1.934v.333c0,1.616,0,3.232-.005,4.847,0,.232.047.321.3.32q3.32-.015,6.64,0c.246,0,.287-.086.287-.3-.005-5.007,0-10.015-.01-15.022a1.193,1.193,0,0,1,.681-1.156c1.588-.882,3.162-1.788,4.741-2.685a.366.366,0,0,0,.163-.175c-.087,0-.173-.012-.26-.012q-6.122,0-12.245,0c-.229,0-.3.061-.3.3.009,2.121.005,4.241.005,6.362v.448c-.115.006-.2.014-.293.015-.421,0-.842,0-1.262,0-.388,0-.388,0-.389-.375q0-1.54,0-3.08,0-2.247.005-4.494a.974.974,0,0,1,1.109-1.12q8.7,0,17.395,0a.962.962,0,0,1,.93.387,1.528,1.528,0,0,1,.212.729c.013,3.812.009,7.625.009,11.437,0,3.147-.007,6.295.006,9.442a1.271,1.271,0,0,1-.743,1.266c-2.131,1.167-4.234,2.386-6.348,3.585-.622.353-1.241.709-1.865,1.057a.985.985,0,0,1-1.54-.9c0-1.119,0-2.239,0-3.358,0-.375,0-.376-.364-.376h-7.524c-.076,0-.151,0-.227,0a.969.969,0,0,1-1.051-1.058c-.007-1.4,0-2.794,0-4.191q0-.959,0-1.919C-1277.558,815.271-1277.55,815.181-1277.545,815.073Z",
    transform: "translate(1286.56 -793.26)",
    fill: "#37bdb0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M-1448.356,957.887c-.816,0-1.632,0-2.449,0a1.366,1.366,0,0,0-1.438,1.367,1.378,1.378,0,0,0,1.447,1.39q2.487,0,4.973,0c.337,0,.339,0,.339.349,0,.715.006,1.431,0,2.146a.644.644,0,0,0,.3.643.616.616,0,0,0,.722-.115l3.306-2.4c.653-.475,1.3-.951,1.96-1.423.515-.371.526-.773.015-1.145q-2.661-1.939-5.326-3.873a.613.613,0,0,0-.663-.087.576.576,0,0,0-.316.582c.005.766,0,1.531.005,2.3,0,.21-.069.276-.277.274C-1446.623,957.882-1447.49,957.887-1448.356,957.887Z",
    transform: "translate(1452.243 -946.827)",
    fill: "#37bdb0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasshboardMaintenanceInUnit);
export default __webpack_public_path__ + "static/media/Dasshboard_Maintenance_In_Unit.21fc5bbc196035c8d3580b5d707ea8c9.svg";
export { ForwardRef as ReactComponent };